import { MODAL_TYPE } from 'config/Constants/index';
import { makeAutoObservable } from 'mobx';

interface IModalInterface {
  modalList: { [key in MODAL_TYPE]: boolean };
  toggleModal: (modalKey: MODAL_TYPE) => void;
  getCurrentInstance: (modalKey: MODAL_TYPE) => boolean;
}

/**
 * modal store
 */
export class GlobalModalStore implements IModalInterface {
  modalList = {
    [MODAL_TYPE.PPS_JPB_PASTE_BULK_UPLOAD_JOBS_MODAL]: false,
    [MODAL_TYPE.PPS_JPB_PASTE_ADD_JOB_MODAL]: false,
    [MODAL_TYPE.PPS_JOB_PASTE_OVERRIDE_CAPTURE_MODAL]: false,
    [MODAL_TYPE.PPS_JOB_PASTE_SCHEDULE_ATTAINMENT_MODAL]: false,
    [MODAL_TYPE.PPS_JOB_PASTE_IMPORT_SYSPRO_JOBS_MODAL]: false
  };

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * toggles state of the modal which matches with the modal key
   * @param modalKey key of modal list object
   */

  toggleModal = (modalKey: MODAL_TYPE) => {
    this.modalList[modalKey] = !this.modalList[modalKey];
  };

  /**
   * Returns state of modal which corresponds to the key supplied
   * @param modalKey key of modal list object
   * @returns instance of modal which belongs to the current key
   */

  getCurrentInstance = (modalKey: MODAL_TYPE) => {
    return this.modalList[modalKey];
  };
}
